module.exports = __webpack_public_path__ + "static/media/coming-soon.3ecc8dd8.svg";